//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'WorkshopDetailsDialog',

	data() {
		return {
			workshopData: false,
		}
	},
	props: {
		workshop: {
			type: Object,
			required: true,
		},
	},

	created() {
		this.workshopData = this.workshop;

		this.recordWorkshopView();
	},

	computed: {
		createdDate() {
			return this.$dayjs(this.workshopData.created_at).format('MMM DD, YYYY');
		},

		startDate(){
			return this.$dayjs(this.workshopData.starts_at).format('DD/MM/YYYY HH:mm');
		},

		endDate(){
			return this.$dayjs(this.workshopData.ends_at).format('DD/MM/YYYY HH:mm');
		},

		deadline(){
			return this.$dayjs(this.workshopData.rsvp_deadline).format('DD/MM/YYYY HH:mm');
		},

		deadlineAfterToday() {
			if (! this.hasDeadline) {
				return true;
			}

			return this.$dayjs().isBefore(this.workshopData.rsvp_deadline);
		},

		hasDeadline() {
			return Boolean(this.workshopData.rsvp_deadline);
		},

		workshopCollection() {
			return this.$store.getters['workshops/getWorkshops'];
		},

		faculties() {
			return this.workshopData.faculties.length
				? this.workshopData.faculties.map((faculty) => faculty.name).join(', ')
				: null;
		},

		/**
		 * Determine whether the target audience should be displayed.
		 *
		 * @return {boolean} True if the workshop has faculties or a target audience or degrees.
		 */
		shouldDisplayTargetAudienceSection() {
			const { faculties, target_audience, degrees } = this.workshopData;

			return faculties?.length || target_audience || degrees;
		},
	},

	methods: {
		async recordWorkshopView() {
			await this.$store.dispatch('workshops/recordsWorkshopView', this.workshop.uuid);
		},

		async registerToWorkshop() {
			await this.$store.dispatch('workshops/registerToWorkshop', this.workshop.uuid).then((res) => {
				this.workshopData = res;
				let workshops = JSON.parse(JSON.stringify(this.workshopCollection));
				let index = workshops.data.findIndex((workshop) => workshop.uuid === res.uuid)

				if(index !== -1){
					workshops.data[index] = res;
				}

				this.$store.dispatch('workshops/setWorkshops', workshops);

			}).catch((err) => {
				this.$toast.show({
					type: 'danger',
					message: err.response.data.message,
				});
			});
		},
	},
}
